import ListItem from "../../../components/ListItem";
import React, { useState } from "react";
import { $ } from "../../../../../vendor";

const ContingentsListItem = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const toggleElement = (ev, key) => {
    $("#resources-panel-" + key).toggleClass("active");
    $("#row-" + key).toggleClass("toggled");
    searchParams.set("item", key);
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  return (
    <>
      <ListItem
        key={props.key}
        listStyle={props.listStyle}
        id={props.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        menu={props.menu}
        refLink={props.refLink}
        length={props.length}
        extra3={true}
        toggleElement={toggleElement}
        multipleCheckins={true}
        contingent={props.contingent}
        dispatch={props.dispatch}
        app_user_role={props.app_user_role}
        setId={true}
        setFilter={props.setFilter}
        filter={props.filter}
        setNKey={props.setNKey}
        sort={props.sort}
        setSort={props.setSort}
      />
    </>
  );
};

export default ContingentsListItem;
